import Carousel from '../modules/carousel'

$.fn.NewsCarousel = function() {
  let self = this
  self.carousel = undefined
  self.pictures = []
  self.interval = undefined

  self.slideChange = function(swiper) {
    self.pictures[swiper.realIndex].removeClass('visible')
    requestAnimationFrame(function() {
      $('.news-slide__picture').removeClass('visible')
      $('.news-carousel__container').append(self.pictures[swiper.realIndex])
      requestAnimationFrame(function() {
        self.pictures[swiper.realIndex].addClass('visible')
      })
    })
  }

  self.swiperInit = function() {
    self.interval = setTimeout(self.swiperNext, 7500)
  }

  self.swiperNext = function() {
    $('.news-carousel__button-next').click()
    self.interval = setTimeout(self.swiperNext, 7500)
  }

  return function() {
    self.find('.news-slide__picture').each(function() {
      self.pictures.push($(this).clone())
    })
    self.carousel = new Carousel(self.get(0), {
      slidesPerView: 1,
      loop: true,
      simulateTouch: false,
      breakpoints: {
        0: {
          autoHeight: true,
        },
        768: {
          autoHeight: false,
        },
      },
      navigation: {
        prevEl: self.find('.news-carousel__button-prev').get(0),
        nextEl: self.find('.news-carousel__button-next').get(0),
      },
      on: {
        slideChangeTransitionStart: self.slideChange,
      }
    }, {
      forceRebuild: true,
    })
    self.find('.news-carousel__button-prev, .news-carousel__button-next').on('click', function() {
      clearInterval(self.interval)
    })
    self.carousel.init()
    self.swiperInit()
    return self
  }()
}
